import React, { forwardRef, useCallback } from "react";
import PropTypes from "prop-types";

function formatPhone(value, countryCode) {
  let digits = String(value || "").replace(/\D/g, "");
  if (countryCode === "AU") {
    digits = digits.slice(0, 10);
    return [digits.slice(0, 4), digits.slice(4, 7), digits.slice(7, 10)]
      .filter(Boolean)
      .join("-");
  }

  if (digits.startsWith("1")) {
    digits = digits.slice(1);
  }

  digits = digits.slice(0, 10);
  if (digits.length <= 3) return digits ? `(${digits}` : "";
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

const TextMaskPhone = forwardRef((props, ref) => {
  const { defaultValue, inputRef, name, onChange, value, ...other } = props;
  const countryCode = sessionStorage.getItem("LSCountryCode");
  const isControlled = value !== undefined;
  const setRef = useCallback(
    (element) => {
      assignRef(ref, element);
      assignRef(inputRef, element);

      if (element && !isControlled) {
        element.value = formatPhone(element.value || defaultValue, countryCode);
      }
    },
    [countryCode, defaultValue, inputRef, isControlled, ref],
  );
  const handleChange = (event) => {
    const formattedValue = formatPhone(event.target.value, countryCode);
    event.target.value = formattedValue;
    onChange?.(event);
  };
  const valueProps = isControlled
    ? { value: formatPhone(value, countryCode) }
    : { defaultValue: formatPhone(defaultValue, countryCode) };

  return (
    <input
      {...other}
      {...valueProps}
      ref={setRef}
      name={name}
      onChange={handleChange}
    />
  );
});
TextMaskPhone.displayName = "TextMaskPhone";
TextMaskPhone.propTypes = {
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
export default TextMaskPhone;
